import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody38';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy38 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Quarterly reporting framework </h2><h4>for a US private equity</h4>";

  return (
    <>
        <Helmet>
        <title>Quarterly reporting framework for a US private equity</title>
        <meta property="og:title" content="Quarterly reporting framework: for a US private equity" />
        <meta property='og:description' content='Quarterly reporting framework: for a US private equity'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy38" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy38 
